import { Check, Pin, UserFilled } from "@assets"
import { Link } from "@inertiajs/react"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { settingsProfilePath } from "@/routes"
import type { User } from "@/types"

export function UserInfo({
  user,
  showEmail = false,
  showNeighborhood = false,
  ref = settingsProfilePath(),
}: {
  user: User
  showEmail?: boolean
  showNeighborhood?: boolean
  ref?: string
}) {
  return (
    <Link
      href={ref}
      prefetch
      className="flex items-center gap-2 py-1.5 text-left text-sm"
    >
      <Avatar className="h-[45px] w-[45px] overflow-hidden rounded-full">
        <AvatarImage src={user.avatar_url ?? undefined} alt={user.name} />
        <AvatarFallback className="bg-modal p-1">
          <UserFilled className="fill-chart-2 h-full w-full" />
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-[14px] leading-tight">
        <div className="text-chart-5 inline-flex h-[22px] items-center gap-1 truncate font-semibold tracking-[0px]">
          <span className="truncate">{user.name}</span>
          {user?.verified && <Check className="fill-primary size-4.5" />}
        </div>
        {showEmail && (
          <span className="text-muted-foreground truncate text-xs">
            {user.email}
          </span>
        )}
        {showNeighborhood && (user.neighborhood ?? undefined) && (
          <div className="text-muted-foreground flex h-[19px] items-start gap-1 truncate text-[13px] font-normal tracking-[0.2px]">
            <Pin className="h-[16px] w-auto" />
            {user.neighborhood?.name}
          </div>
        )}
      </div>
    </Link>
  )
}
